export default [
    {
        path: "/admin/dashboard",
        name: "adminDashboard",
        component: () => import("@/pages/admin/dashboard/Dashboard.vue"),
        meta: {
            pageTitle: "Dashboard",
            icon: "icon-[ic--twotone-space-dashboard]",
            layout: "LayoutAdmin",
            resource: "admin",
            action: "read",
        },
    },
    {
        path: "/admin/workshop",
        name: "adminWorkshop",
        component: () => import("@/pages/admin/AdminWorkshop.vue"),
        meta: {
            pageTitle: "Daftar Kegiatan",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutAdmin",
            resource: "sysdev",
            // resource: "pelatihan",
            action: "read",
        },
    },
    {
        path: "/admin/hypierslink",
        name: "adminHypierslink",
        component: () => import("@/pages/admin/AdminHypierslink.vue"),
        meta: {
            pageTitle: "Hiperlink Diklat",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutAdmin",
            resource: "sysdev",
            // resource: "pelatihan",
            action: "read",
        },
    },
    {
        path: "/admin/list-certificate",
        name: "adminListCertificate",
        component: () => import("@/pages/admin/adminListCertificate.vue"),
        meta: {
            pageTitle: "Daftar Sertifikat",
            icon: "icon-[ph--chalkboard-teacher-duotone]",
            layout: "LayoutAdmin",
            resource: ["admin", "sysdev"],
            // resource: "pelatihan",
            action: "read",
        },
    },
    {
        path: "/admin/surat-menyurat",
        name: "adminSuratMenyurat",
        component: () => import("@/pages/admin/AdminSuratMenyurat.vue"),
        meta: {
            pageTitle: "Daftar Surat Menyurat",
            icon: "icon-[ph--envelope-duotone]",
            layout: "LayoutAdmin",
            resource: ["admin", "sysdev"],
            action: "read",
        },
    },
];
